import { defineMessages } from 'react-intl';

export const messages: {
	redactedAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	enforcementMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	redactedAriaLabel: {
		id: 'conversation-assistant.redacted-prompt.redacted-aria-label-nonfinal',
		defaultMessage: 'redacted',
		description:
			'Accessible label for a visually redacted segment of a user prompt (shown as a dark scribble bar).',
	},
	enforcementMessage: {
		id: 'conversation-assistant.redacted-prompt.enforcement-message-nonfinal',
		defaultMessage: 'Redacted by your organization',
		description:
			'Enforcement label shown below a redacted prompt, indicating the message was redacted by an org policy.',
	},
});
